import React from 'react';
import { Button } from '../../components/ui/button';
import { ArrowRight } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../components/ui/accordion';

const FAQSection = ({ faqItems, onContactClick }) => (
  <section className="py-20 md:py-24 bg-tp-bg" id="faq" data-testid="faq-section">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <h2 className="text-2xl md:text-3xl font-display font-semibold text-tp-text mb-4">Questions fréquentes</h2>
        <p className="text-tp-text-light">Tout ce que vous devez savoir avant de commencer</p>
      </div>
      
      <Accordion type="single" collapsible className="space-y-3">
        {faqItems.map((item, index) => (
          <AccordionItem 
            key={item.question} 
            value={`item-${index}`}
            className="bg-white border border-tp-border rounded-lg px-6 data-[state=open]:shadow-md transition-all"
            data-testid={`faq-item-${index}`}
          >
            <AccordionTrigger className="text-left font-medium text-tp-text hover:no-underline py-4">
              {item.question}
            </AccordionTrigger>
            <AccordionContent className="text-tp-text-light pb-4 leading-relaxed">
              {item.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
      
      <div className="text-center mt-10">
        <p className="text-sm text-tp-text-light mb-4">Vous avez d'autres questions ?</p>
        <Button onClick={onContactClick} variant="outline" className="gap-2 border-tp-border text-tp-primary hover:bg-white">
          Contactez-nous <ArrowRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  </section>
);

export default FAQSection;
